<template>
    <div>
        <input-validate
            title="Name"
            type="text" 
            name="pnname" 
            v-model="pnname" 
            placeholder="Enter your name" 
            v-validate="'required|pnname'"
            data-vv-value-path="innerValue" 
            data-vv-validate-on="blur"
            :error="errors.first('pnname')">
        </input-validate>

        <input-validate
            title="Account"
            type="text" 
            name="account" 
            v-model="account" 
            placeholder="Enter your account" 
            v-validate="'required|account'"
            data-vv-value-path="innerValue" 
            data-vv-validate-on="blur"
            :error="errors.first('account')">
        </input-validate>
        <input-validate
            title="Password"
            type="password" 
            name="password" 
            v-model="password" 
            placeholder="Enter your password" 
            v-validate="'required|password'"
            data-vv-value-path="innerValue" 
            data-vv-validate-on="blur"
            :error="errors.first('password')">
        </input-validate>
        <input-validate
            title="UPI ID"
            type="text" 
            name="upiid" 
            v-model="upiid" 
            placeholder="Enter UPI ID" 
            v-validate="'required|upiid'"
            data-vv-value-path="innerValue" 
            data-vv-validate-on="blur" 
            :error="errors.first('upiid')">
        </input-validate>
        <div class="upi-tips">
            In order to avoid harassment and protect your privacy, please do not use phone numbers as UPI addresses, use letters or names as UPI
        </div>
        <md-button class="mt-3" type="primary" :loading="link_loading" :disabled="link_loading" @click="submit_ct" v-if="edit">Save</md-button>
        <md-button class="mt-3" type="primary" :loading="link_loading" :disabled="link_loading" @click="submit_ct" v-else>Add Kyc Partner</md-button>
    </div>
</template>

<script>
import { Validator } from "vee-validate";
import inputValidate from "@/components/input-validate";
import { addcollectiontool, editcollectiontool } from '@/request/api'

Validator.extend("account", {
    getMessage: field => `${field} value do not meet right format`,
    validate: value => {
        if(value.length > 3) {
            return true;
        } else {
            return false;
        }
    }
});
Validator.extend("password", {
    getMessage: field => `${field} value do not meet right format`,
    validate: value => {return true}
});
Validator.extend("upiid", {
    getMessage: field => `${field} value do not meet right format`,
    validate: value => /^[\s\S]*@[\s\S]*$/.test(value)
});
Validator.extend("pnname", {
    getMessage: field => `${field} value do not meet right format`,
    validate: value => {return true}
});


export default {
    name: 'accountform',
    components: {
        inputValidate
    },
    props: {
        type: {
            type: String,
            default: ""
        },
        ct: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            edit: false,
            account: "",
            upiid: "",
            password: "",
            pnname: "",
            link_loading: false
        }
    },
    created() {
        console.log(this.ct);
        if(this.ct) {
                this.account = this.ct.account;
                this.upiid = this.ct.upi;
                this.edit = true;
                this.password = this.ct.password;
                this.pnname = this.ct.pnname;
            } else {
                this.account = "";
                this.upiid = "";
                this.password = "";
                this.pnname = "";
                this.edit = false;
            }
    },
    methods: {
        submit_ct() {
            let that = this;
            if(this.type === '') {
                this.$toast.failed("please select the kyc partner");
                return false;
            }
            this.link_loading = true
            const success = this.$validator.validateAll().then(res=>{
                if(res) {
                    if(this.edit) {
                        if(this.type !== this.ct.type) {
                            this.$toast.failed("The link kyc type cannot be changed, please go back and recreate the link");
                            that.link_loading = false;
                            return
                        }

                        let formdata = {id: this.ct.id}
                        
                        if(this.ct.account === this.account && this.ct.upi === this.upiid && this.ct.pnname === this.pnname) {
                            this.$toast.succeed("no changes made");
                            that.link_loading = false;
                            return
                        }
                        if(this.ct.upi !== this.upiid) {
                            formdata.upi = this.upiid;
                        }
                        if(this.ct.account !== this.account) {
                            formdata.account = this.account;
                        }
                        if(this.ct.password !== this.password){
                            formdata.password = this.password;
                        }
                        if(this.ct.pnname !== this.pnname) {
                            formdata.pnname = this.pnname;
                        }

                        editcollectiontool(formdata).then(res=>{
                            that.link_loading = false;
                            if(res.code === 200) {
                                that.$toast.succeed('save successfully, please link to activate');
                                setTimeout(()=>{
                                    that.$router.push("/kycpartner");
                                }, 2000);
                            } else {
                                that.$toast.failed(res.errmsg);
                            }
                        }).catch(error=>{
                            console.log(error);
                            that.$toast.failed("Network Error!");
                            that.link_loading = false;
                        })
                    } else {
                        addcollectiontool({
                            type: that.type,
                            account: that.account,
                            upi: that.upiid,
                            password: that.password,
                            pnname: that.pnname
                        }).then(res=>{
                            that.link_loading = false;
                            if(res.code === 200) {
                                that.$toast.succeed('Add successfully, please link to activate');
                                setTimeout(()=>{
                                    that.$router.push("/kycpartner");
                                }, 1200);
                            } else {
                                that.$toast.failed(res.errmsg);
                            }
                        }).catch(error=>{
                            console.log(error);
                            that.$toast.failed("Network Error!");
                            that.link_loading = false;
                        })
                    }
                } else {
                    that.link_loading = false;
                    return
                }
            })
        },
    }
}

</script>
<style scoped>
.upi-tips {
    margin-top: 0.3rem;
    color: #46ac2a;
    font-size: 0.20rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/forms/accountform.vue